import { createDomain } from 'effector-root';

const domain = createDomain('OrdersReport (Page)');

export const onPageStarted = domain.event();